import React from "react"
import styles from "./FastMovingBadgePreview.module.css"

/**
 * Read-only fast-moving overlay badge for item previews.
 * Uses tenant delivery-settings iconUrl (same source as mobile / website-template).
 *
 * variant:
 * - "chip"  — white circular chip (web ProductCard style)
 * - "plain" — raw icon only (mobile truck badge style)
 */
const FastMovingBadgePreview = ({
  isFastMoving,
  iconUrl,
  settingsEnabled,
  className = "",
  size = 28,
  placement = "overlay",
  variant = "chip",
}) => {
  const url = typeof iconUrl === "string" ? iconUrl.trim() : ""
  if (!isFastMoving || !settingsEnabled || !url) return null

  return (
    <span
      className={`${styles.badge} ${
        variant === "plain" ? styles.plain : styles.chip
      } ${placement === "overlay" ? styles.overlay : styles.inline}${
        className ? ` ${className}` : ""
      }`}
      style={{ ["--fast-badge-size"]: `${size}px` }}
      aria-label="Fast-moving item"
      title="Fast-moving item"
    >
      <img src={url} alt="" className={styles.icon} width={size} height={size} />
    </span>
  )
}

export default FastMovingBadgePreview
